export default __webpack_public_path__ + "5bc016c2d0518e2fc16d69445fa1c61d.png";